import React, { useEffect, useState } from "react";
import defaultImg from "../../assets/WidgetMaker/Brocken_Image.svg";
import Profile from "../../assets/Profile_Pic.svg";
import verified from "../../assets/verified.svg";
import BoostedPostIcon from "../../assets/boosted_post_icon.svg";
import AdsPostIcon from "../../assets/ads_post_icon.svg";
import ClockIcon from "../../assets/Clock.svg";
import Image from "antd/lib/image";
import Popover from "antd/lib/popover";
import { useSelector } from "react-redux";
import Tooltip from "antd/lib/tooltip";
import moment from "moment";
import { getDynamicIconColor } from "../../redux/constants/DynamicIconColor";
import { getTextDirection } from "../../redux/constants";

const QuotedPost = ({
  el,
  i,
  PdfDownloadStatus,
  PptGeneratingStatus,
  trendView,
  isDeepDiveDashboardView = false,
}) => {
  const authParams = useSelector((state) => state.Authentication.authParams);
  const [isImage, setIsImage] = useState({});
  const [postText, setPostText] = useState(null);

  const urlify = (text) => {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    return text?.replace(urlRegex, function (url) {
      return (
        '<a style="color: blue" target="_blank" rel="noreferrer" href="' +
        url +
        '">' +
        url +
        "</a>"
      );
    });
    // or alternatively
    // return text.replace(urlRegex, '<a href="$1">$1</a>')
  };
  let textDirection = getTextDirection(el?.PostText || "");
  let textDirectionClass = textDirection === "rtl" ? "text-right-arabic" : "";

  useEffect(() => {
    var text = el?.PostText;
    let html = urlify(text);
    if (textDirection === "rtl") {
      html = html.replace(/(@\w+)/g, '<span dir="ltr">$1</span>');
    }

    setPostText(html);
  }, []);

  const getDefautProfileImg = (e) => {
    return (e.target.src = Profile);
  };

  return (
    <div
      className={`${
        PdfDownloadStatus
          ? "pdf-quoted-post-container"
          : "quoted-post-container"
      }`}
    >
      <div
        style={{ paddingTop: PdfDownloadStatus ? "0.5rem" : "1.5rem" }}
        className="card-head text_heading d-flex justify-content-between p-15 pb-0 mt-0 align-items-top"
      >
        <div
          className="d-flex align-items-center"
          style={{ width: trendView ? "60%" : "75%" }}
        >
          <div
            className="position-relative mr-15"
            style={{ width: "3.5rem", marginLeft: "-0.5rem" }}
          >
            {!PdfDownloadStatus && !PptGeneratingStatus ? (
              el?.AuthorBio &&
              el?.AuthorBio !== "NA" &&
              el?.AuthorBio !== "" ? (
                <Popover
                  placement="leftBottom"
                  title={null}
                  content={
                    el?.AuthorBio &&
                    el?.AuthorBio !== "NA" &&
                    el?.AuthorBio !== "" && (
                      <div
                        style={{
                          maxWidth: "25rem",
                          maxHeight: "20rem",
                          overflow: "auto",
                        }}
                        className="text_regular fontSize-12 p-15 custom_scroll1"
                      >
                        {el?.AuthorBio}
                      </div>
                    )
                  }
                  overlayClassName={
                    authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                  }
                >
                  <Image
                    src={
                      el?.ProfilePicture === 0 ||
                      el?.ProfilePicture === "" ||
                      !el?.ProfilePicture
                        ? Profile
                        : el?.ProfilePicture
                    }
                    fallback={Profile}
                    preview={false}
                    alt="Profile Images"
                    className="profileImg ml-1 cursor-pointer"
                    style={{ width: "3rem", height: "3rem" }}
                    crossOrigin="anonymous"
                  />
                </Popover>
              ) : (
                <Image
                  src={
                    el?.ProfilePicture === 0 ||
                    el?.ProfilePicture === "" ||
                    !el?.ProfilePicture
                      ? Profile
                      : el?.ProfilePicture
                  }
                  fallback={Profile}
                  preview={false}
                  alt="Profile Images"
                  className="profileImg ml-1 cursor-pointer"
                  style={{ width: "3rem", height: "3rem" }}
                  crossOrigin="anonymous"
                />
              )
            ) : (
              <Image
                src={
                  PdfDownloadStatus || PptGeneratingStatus
                    ? el?.ProfilePicture === 0 ||
                      el?.ProfilePicture === "" ||
                      !el?.ProfilePicture
                      ? Profile
                      : el?.ProfilePicture
                    : Profile
                }
                fallback={Profile}
                preview={false}
                alt="Profile Images"
                style={{ width: "2.5rem", height: "2.5rem" }}
                crossOrigin="anonymous"
                onError={getDefautProfileImg}
              />
            )}
          </div>
          <div
            style={{
              width: PdfDownloadStatus ? "100%" : "calc(100% - 6rem)",
            }}
          >
            <div className="d-flex flex-wrap align-items-center">
              <Tooltip title={el?.AuthorName}>
                <div
                  className={`${
                    authParams?.screen_id && !isDeepDiveDashboardView
                      ? "text_regular-cc"
                      : ""
                  }
                  ${
                    PdfDownloadStatus
                      ? "pdf-quoted-profileName"
                      : "quoted-profileName"
                  } "text-ellipsis line-height-normal"`}
                >
                  {trendView
                    ? el?.AuthorName?.length > 8
                      ? el?.AuthorName?.substr(0, 8) + " ..."
                      : el?.AuthorName
                    : el?.AuthorName?.length > 15
                    ? el?.AuthorName?.substr(0, 15) + " ..."
                    : el?.AuthorName}
                </div>
              </Tooltip>
              <div>
                {el?.ScreenName && (
                  <div
                    className={`${
                      PdfDownloadStatus
                        ? "pdf-quoted-screenName"
                        : "quoted-screenName"
                    }  "text-grayLight text-ellipsis w-100"`}
                  >
                    <Tooltip title={el?.ScreenName}>
                      {trendView
                        ? el?.ScreenName?.length > 8
                          ? el?.ScreenName?.substr(0, 8) + " ..."
                          : el?.ScreenName
                        : el?.ScreenName?.length > 15
                        ? el?.ScreenName?.substr(0, 15) + " ..."
                        : el?.ScreenName}
                    </Tooltip>
                  </div>
                )}
              </div>
              {el?.AuthorIsVerified !== "NA" &&
              el?.AuthorIsVerified &&
              el?.AuthorIsVerified > 0 ? (
                <img
                  src={verified}
                  alt="verified"
                  className="profileImg ml-1"
                  style={{ height: "1.6rem" }}
                />
              ) : (
                ""
              )}
              {el?.isPromoted === 1 ? (
                <Tooltip title="Boosted post">
                  <img
                    alt="Boosted Post Icon"
                    src={BoostedPostIcon}
                    className="mr-0"
                    style={{
                      width: "2rem",
                      height: "2rem",
                    }}
                  />
                </Tooltip>
              ) : el?.isPromoted === 2 || el?.isPromoted === 5 ? (
                <Tooltip
                  title={el?.isPromoted === 5 ? "Dark Ad Post" : "Ad Post"}
                >
                  <img
                    alt="Ad Post Icon"
                    src={AdsPostIcon}
                    className="mr-0"
                    style={{
                      width: "2rem",
                      height: "2rem",
                    }}
                  />
                </Tooltip>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <span
          className="font-size12 align-items-center d-flex"
          style={{ maxWidth: trendView ? "40%" : "25%" }}
        >
          <Tooltip
            title={
              <div>
                Created Date : <br />{" "}
                {el?.CreatedDate ? el?.CreatedDate : el?.PostCreatedDate}
              </div>
            }
            className="no--wrap"
          >
            <span
              className="cardList__footer-label"
              style={{
                width: PdfDownloadStatus ? "1.3rem" : "",
                height: PdfDownloadStatus ? "1.3rem" : "",
                marginRight: "0.3rem",
              }}
            >
              {getDynamicIconColor("clock_icon")}
            </span>
            <span
              className={`${
                PdfDownloadStatus ? "pdf-quoted-date" : ""
              } "cardList__footer-count text-grayLight"`}
            >
              {PdfDownloadStatus
                ? el?.CreatedDate
                  ? moment(el?.CreatedDate)?.format("DD MMM YY")
                  : moment(el?.PostCreatedDate)?.format("DD MMM YY")
                : el?.CreatedDate
                ? moment(el?.CreatedDate)?.format("DD MMM YYYY")
                : moment(el?.PostCreatedDate)?.format("DD MMM YYYY")}
            </span>
          </Tooltip>
        </span>
      </div>
      <div className="card-body p-0" style={{ marginTop: "1rem" }}>
        <div
          className={`cardList__body-description fontSize-12 pl-15 pr-15`}
          style={
            PdfDownloadStatus
              ? { marginTop: "-0.5rem" }
              : {
                  //   height: el?.PlatformID === 1 ? "16.3rem" : "20rem",
                  overflow: "hidden",
                }
          }
        >
          {el?.PostText && (
            <div
              className={`${
                authParams?.screen_id && !isDeepDiveDashboardView
                  ? "text_regular-cc"
                  : "text_regular"
              }
               ${
                 PdfDownloadStatus
                   ? "pdf-quoted-truncate-text"
                   : "quoted-truncate-text"
               } break-word mb-1 ${textDirectionClass}`}
              dangerouslySetInnerHTML={{ __html: postText }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default QuotedPost;
